import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: {
    status: "ACTIVE",
    updatedAt: "2026-08-05T09:30:00Z",
  },
  chat: {
    status: "ACTIVE",
    reply: "The Support List provides four key pieces of information for compatible devices:- **DAP-X3060:** The product series or model family.- **v1.10r025:** The hardware revision (essential for correct firmware matching).- **v1.10r025:** The latest available firmware version.- **2026/05/08 2:26 PM:** When the firmware version was officially released.![](https://d3sn9tjkzwe4m8.cloudfront.net/qa/Firmware%20Management/figure_support_list_ap_p098.jpg)",
    relatedQuestions: [
      {
        qaId: "96e45554-218f-4ba1-bce2-ec520b593370",
        question: "What kind of detailed device information can I view and modify directly from the Topology map?"
      },
      {
        qaId: "abbad29a-c11a-412d-8d84-49b6541ab1bc",
        question: "What does each item in the main Nuclias Unity menu do?"
      },
      {
        qaId: "2e325c6b-3300-4796-90ab-5a597468a9c9",
        question: "How does Nuclias Unity serve enterprise and campus environments?"
      }
    ],
  },
};

export const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    setChatbotStatus: (state, action) => {
      state.status.status = action.payload;
    },
    setMockChatResponse: (state, action) => {
      state.chat = action.payload;
    },
  },
});

export const { setChatbotStatus, setMockChatResponse } = chatbotSlice.actions;

export default chatbotSlice.reducer;
